// src/components/dispatch/components/TransportDetailsCard.jsx
import React from 'react';
import Select from 'react-select';

function TransportDetailsCard({ form, handleChange, transporters, subTransporters }) {
  return (
    <div className="card mb-4 border-left-primary shadow-sm">
      <div className="card-body">
        <h5 className="card-title text-primary mb-3">Transport Details</h5>
        <div className="row g-3">
          <div className="col-md-3">
            <label className="form-label">Dispatch Date</label>
            <input
              type="date"
              name="dispatch_date"
              className="form-control"
              value={form.dispatch_date}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Transporter</label>
            <Select
              options={transporters}
              value={transporters.find(opt => opt.value === form.transporter_id)}
              onChange={(selected) => {
                const transporterId = selected?.value || '';
                handleChange({ target: { name: 'sub_transporter_id', value: '' } });
                handleChange({ target: { name: 'transporter_id', value: transporterId } });
              }}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Sub Transporter</label>
            <Select
              options={subTransporters}
              value={subTransporters.find(opt => opt.value === form.sub_transporter_id) || null}
              onChange={(selected) => handleChange({ target: { name: 'sub_transporter_id', value: selected?.value || '' } })}
              isDisabled={!form.transporter_id}
              placeholder={form.transporter_id ? 'Select Sub Transporter' : 'Select Transporter First'}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default TransportDetailsCard;
